import * as SC from "./styles";
import { useParams } from "react-router-dom";
import { ProductList } from "components/ProductList";
import { useEffect, useState } from "react";
import Banner from "components/Banner";
import { useProduct } from "contexts/ProductsContext";
import ProductDetails from "modules/DetailsProduct/components/DetailsProduct";

const DetailsPage = () => {
  const { products, urlThumb, setUrlThumb } = useProduct();
  const { id } = useParams();
  const [loading, setLoading] = useState(true); // Set initial loading state to true

  const product = products.find((product) => product.id === Number(id));

  const images = {
    imageUrl: product?.imagens?.[0]?.url,
    description: product?.imagens?.[0]?.descricao,
  };

  useEffect(() => {
    if (products.length > 0) { // Check if products have been fetched
      setLoading(false); // Set loading to false if products have been fetched
    }
  }, [products]); // Add products as a dependency

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    if (images.imageUrl) {
      setUrlThumb(images.imageUrl);
    }
  }, [images.imageUrl, setUrlThumb]); // Add dependencies

  if (loading) { // Check if loading is true
    return <div>Loading...</div>; // Return loading screen
  }

  if (!product) {
    console.log('Error: Product not found'); // Log an error message if the product is not found
    return <div>Error</div>;
  }

  return (
    <>
      <SC.Product>
        <SC.ProductImage>
          <img src={urlThumb} alt={images.description} />
        </SC.ProductImage>
        <ProductDetails product={product} />
      </SC.Product>
      <Banner />
      <ProductList
        title={`View similar items to ${product.nome}`}
        random={true}
      />
    </>
  );
};

export default DetailsPage;
